
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/singlePost",
      function () {
        return require("private-next-pages/community/singlePost.tsx");
      }
    ]);
  